import { contrastRatio } from "toolbox/Colors";

const WHITE = "#FFFFFF";
const BLACK = "#000000";
/** WCAG AA for body text on the header band. */
const TEXT_CONTRAST = 4.5;
/** WCAG AA for a graphic (the gauge's fill) against the white card. */
const GRAPHIC_CONTRAST = 3;
const STEP = 0.05;

const channels = (hex: string) => {
  const match = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!match) throw new Error(`"${hex}" is not a #RRGGBB colour`);
  return match.slice(1).map((channel) => parseInt(channel, 16));
};

/** `hex` moved `weight` (0..1) of the way toward `toward`. */
export const mixHex = (hex: string, toward: string, weight: number) => {
  const from = channels(hex);
  const to = channels(toward);
  return `#${from
    .map((channel, index) =>
      Math.round(channel + (to[index] - channel) * weight)
        .toString(16)
        .padStart(2, "0"),
    )
    .join("")}`;
};

/** The tier colour darkened, from `startWeight`, until `ink` reads on it at `ratio`. */
const darkenUntilReadable = (hex: string, ink: string, ratio: number, startWeight: number) => {
  for (let weight = startWeight; weight < 1; weight += STEP) {
    const tone = mixHex(hex, BLACK, weight);
    if (contrastRatio(tone, ink) >= ratio) return tone;
  }
  return BLACK;
};

/**
 * The deep tone of a tier colour for the status header band and celebration backdrop: at least
 * half-way to black, and dark enough that white text on it meets WCAG AA.
 */
export const deepTierTone = (hex: string) => darkenUntilReadable(hex, WHITE, TEXT_CONTRAST, 0.5);

/** The tier colour as a gauge fill on white: as it is when it reads, else darkened until it does. */
export const gaugeTierTone = (hex: string) => darkenUntilReadable(hex, WHITE, GRAPHIC_CONTRAST, 0);

/** Light tints of the tier colour for the celebration's sparkles. */
export const sparkleTierTones = (hex: string) => [
  hex,
  mixHex(hex, WHITE, 0.45),
  mixHex(hex, WHITE, 0.8),
  WHITE,
];
